import { useQuery } from '@tanstack/react-query';
import { MONITORING_TAGS } from 'constants/monitoring';
import { EnhancedError } from 'shared/utils/errors';
import { getQueryKeyForInternal } from 'state/utils/getQueryKeyForInternal';

import { GetProductsOptions, ProductResponse } from './types';

export function getQueryKeyForGetProducts() {
  return getQueryKeyForInternal({
    keys: ['products']
  });
}

const getProducts = async () => {
  try {
    return {
      count: 0,
      items: [],
      limit: 0,
      page: 0,
      total_count: 0
    } as ProductResponse;
  } catch (error) {
    throw new EnhancedError({
      cause: error,
      tags: {
        [MONITORING_TAGS.CART]: true,
        [MONITORING_TAGS.FETCH_PRODUCTS]: true
      }
    });
  }
};

export const useGetProducts = () => {
  return () => getProducts();
};

export function useQueryGetProducts({ isEnabled = true }: GetProductsOptions = {}) {
  return useQuery({
    enabled: isEnabled,
    queryKey: getQueryKeyForGetProducts(),
    queryFn: useGetProducts()
  });
}

type MaybeID = number | undefined;
export function getQueryKeyForGetProductByID(id: MaybeID) {
  return getQueryKeyForInternal({
    keys: ['products', id]
  });
}

const getProductByID = async ({ id }: { id: MaybeID }) => {
  // No ID, nothing to fetch.
  if (id === undefined) {
    return null;
  }

  try {
    return null;
  } catch (error) {
    throw new EnhancedError({
      cause: error,
      tags: {
        [MONITORING_TAGS.CART]: true,
        [MONITORING_TAGS.FETCH_PRODUCTS]: true
      }
    });
  }
};

export const useGetProductByID = (id: MaybeID) => {
  return () => getProductByID({ id });
};

export function useQueryGetProductByID(id: MaybeID, { isEnabled = true }: GetProductsOptions = {}) {
  return useQuery({
    retry: false,
    enabled: isEnabled,
    queryKey: getQueryKeyForGetProductByID(id),
    queryFn: useGetProductByID(id)
  });
}
